/**
 * 管理后台 - 活动议程 API
 */

import { httpGet, httpPost, httpPut, httpDelete } from '@/services/http';

/** 活动议程接口 */
export interface Agenda {
  id?: number;
  event_id: number;
  time: string;
  end_time?: string;
  title: string;
  title_en?: string;
  description?: string;
  description_en?: string;
  location?: string;
  location_en?: string;
  speaker_id?: number;
  speaker_name?: string;
  speaker_title?: string;
  speaker_institution?: string;
  sort_order?: number;
  is_active?: boolean;
  created_at?: string;
  updated_at?: string;
}

/** GET /api/admin/agendas - 获取活动的所有议程 */
export async function getEventAgendas(eventId: number): Promise<Agenda[]> {
  try {
    const data = await httpGet<Agenda[]>(`/admin/agendas?event_id=${eventId}`);
    return data || [];
  } catch (error) {
    console.error('获取活动议程失败:', error);
    return [];
  }
}

/** POST /api/admin/agendas - 创建议程 */
export async function createAgenda(data: Partial<Agenda>): Promise<Agenda | null> {
  try {
    return await httpPost<Agenda>('/admin/agendas', data);
  } catch (error) {
    console.error('创建议程失败:', error);
    throw error;
  }
}

/** PUT /api/admin/agendas/:id - 更新议程 */
export async function updateAgenda(id: number, data: Partial<Agenda>): Promise<Agenda | null> {
  try {
    return await httpPut<Agenda>(`/admin/agendas/${id}`, data);
  } catch (error) {
    console.error('更新议程失败:', error);
    throw error;
  }
}

/** DELETE /api/admin/agendas/:id - 删除议程 */
export async function deleteAgenda(id: number): Promise<boolean> {
  try {
    await httpDelete(`/admin/agendas/${id}`);
    return true;
  } catch (error) {
    console.error('删除议程失败:', error);
    throw error;
  }
}

/** PATCH /api/admin/agendas/batch-sort - 批量更新议程排序 */
export async function batchUpdateAgendaSort(agendas: Array<{id: number; sort_order: number}>): Promise<boolean> {
  try {
    await httpPatch('/admin/agendas/batch-sort', agendas);
    return true;
  } catch (error) {
    console.error('批量更新议程排序失败:', error);
    throw error;
  }
}
